<template>
    <transition name="fade" mode="out-in">
        <div :class="['dt-item-card', type]" :style="position" @mousedown="prepareMove" >
            <div class="handler h-top" v-if="type==='clock'" @mousedown.prevent.stop="prepareResizeUp"><i class="fas fa-chevron-up"></i></div>
            <div class="top">
                <header :class="{'flex-column': type === 'clock'}">
                    <template v-if="type !== 'clock'">
                        <span class="decorator" :style="{ backgroundColor: scheduledItem.colorCode }">
                        </span>
                    </template>
                    <h1 :class="{ 'header--clock' : type === 'clock' }" v-tooltip="{data: scheduledItem.name, arrowPosition: 'top', isDisabled: type !== 'clock' }">
                        <span v-if="type === 'clock'" class="decorator" :style="{ backgroundColor: scheduledItem.colorCode }"></span>
                        {{scheduledItem.name}}
                    </h1>
                    <div v-if="type === 'podcast' && scheduledItem.repeat" style="display: flex; align-items: center;">
                        <Tooltip placement="bottom">
                            <template v-slot:info>
                                <div style="display: flex; flex-direction: column; max-height: 400px; overflow-y: auto; padding: 18px;">
                                    <span class="default-tooltip-label">Repeat count : {{ scheduledItem.repeatCount}}</span>
                                    <span class="default-tooltip-label">Repeat delay : {{ scheduledItem.repeatDelay}} min</span>
                                    <div style="border-top: 1px solid white; padding: 4px 0"></div>
                                    <p class="default-tooltip-label" style="margin: 0; padding: 0">Repeat at :</p>
                                    <span class="default-tooltip-label" v-for="n in (scheduledItem.repeatCount ? scheduledItem.repeatCount : 0)" :key="n">{{ calculateNextRepeat(n)}}</span>
                                </div>
                            </template>

                            <template v-slot:content>
                                <div class="repeat-info__container">
                                    <span>{{ scheduledItem.repeatCount}}</span>
                                    <i class="fas fa-redo"></i>
                                </div>
                            </template>
                        </Tooltip>
                    </div>
                    <div :class="{'align-left': type === 'clock'}" style="display: flex; overflow: hidden; font-size: 14px;">
                        <span>
                            {{minToMoment(scheduledItem.minuteFrom).format('HH:mm')}}
                            <template v-if="scheduledItem.to">
                                - {{ minToMoment(scheduledItem.minuteTo).format('HH:mm')}}
                            </template>
                        </span>
                        <span class="actions" >
                            <i class="fas fa-cog" @mouseup.prevent.stop @click="prepareEditing"></i>
                            <i class="fas fa-trash-alt" @mouseup.prevent.stop @click="prepareDeleting"></i>
                        </span>
                    </div>
                </header>
            </div>
            <div class="handler  h-bottom" v-if="type=='clock'" @mousedown.prevent.stop="prepareResizeDown"><i class="fas fa-chevron-down"></i></div>
        </div>
    </transition>
</template>
<script>
    import Moment from 'moment'
    import Button from'@/components/common/Button.vue'
    import Tooltip from '@/components/common/Tooltip.vue'
    const BaseScheduledItemCard =
    {
        components: { Button, Tooltip },
        props: {
            type: { type: String, required: true },
            scheduledItem: { type: Object, required: true },
            //ratio: { type: Number, default: 100 },
            //displayOrder: { type: Number, default: 0 },
            tooltipHelperSize: { type: Number, default: 5 }
        },
        data() {
            //console.log(JSON.stringify(this.scheduledItem));
            return this.scheduledItem;
        },
        watch:
        {
            //['scheduledItem']: function (to, from) {
            //    console.log(JSON.stringify(from), '!---->', JSON.stringify(to))
            //    console.log(this.position());
            //}
        },
        computed: {
            //startTime: function () { if (!this.scheduledItem) return undefined; return Moment(this.scheduledItem.from, 'HH:mm:ss'); },
            //endTime: function () { if (!this.scheduledItem) return undefined; return Moment(this.scheduledItem.to, 'HH:mm:ss'); },
            // keep it for redirect links
            displayOrder: function () {
                return (this.interval || {}).displayOrder || 0
            },
            ratio: function () {
                return (this.interval || {}).ratio || 100;
            },
            position: function () {
                var style = {
                    left: 'calc(' + ((this.displayOrder || 0) * ((this.ratio || 100))) + '% + '
                        + ((this.displayOrder || 0) * this.tooltipHelperSize) + 'px)'
                    , width: ((this.ratio || 100)) + '%'
                    , top: this.toMinPercentage(this.scheduledItem.minuteFrom) + '%'
                    , height: (this.toMinPercentage(this.scheduledItem.minuteTo - this.scheduledItem.minuteFrom)) + '%'
                }
                return style;
            },
        },
        methods: {
            calculateNextRepeat(n) {

                return Moment(`01-01-2019 ${this.scheduledItem.from}`).add(n * this.scheduledItem.repeatDelay, "m").format("HH:mm");
            },
            toMinPercentage: function (minOfDay) { return minOfDay / 1440 * 100; },
            prepareDeleting(e) {
                console.log("prepareDelete", this.scheduledItem);
                this.$emit("onScheduledItemDeleting", e, {
                    scheduledItem: this.scheduledItem,
                });
            },
            prepareEditing(e) {
                console.log("prepareEditing");
                this.$emit("onScheduledItemEditing", e, {
                    scheduledItem: this.scheduledItem,
                });
            },
            prepareResizeUp(e) {
                console.log("prepareResize");
                this.$emit("onScheduledItemMoving", e, {
                    scheduledItem: this.scheduledItem,
                    type: this.type,
                    mode: 'resize',
                    up: true
                });
            },
            prepareResizeDown(e) {
                console.log("prepareResize");
                this.$emit("onScheduledItemMoving", e, {
                    scheduledItem: this.scheduledItem,
                    type: this.type,
                    mode: 'resize',
                    up: false
                });
            },
            prepareMove(e) {
                console.log("onScheduleItemMoving");
                this.$emit("onScheduledItemMoving", e, {
                    scheduledItem: this.scheduledItem,
                    type: this.type,
                    mode: 'move',
                });
            },

        }
    }

    export default BaseScheduledItemCard
</script>

<style scoped>
    .repeat-info__container {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        font-size: 12px;
        margin-right: 12px;
        z-index: 99999;
    }
    .align-left{
        padding-left: 22px;
    }
</style>
